import {
  showLog,
  showError
} from './logger';
import { GPT_URL } from './constants';
const _files = {};

/**
 * Check if a object is empty or is undefined. Not be used for arrays or strings
 * @param  {mixed} value
 * @return {boolean}
 */
export function isEmpty(value) {// OK
  if ((typeof value === 'object' && Object.keys(value).length) ||
      (typeof value !== 'object' && typeof value !== 'undefined')) {
    return false;
  }

  return true;
}

/**
 * Get a URL param value
 * @param {string} paramName
 * @param {string} url
 */
export function getParameterByName(paramName, url = window.location.href) {
  var regExp, results;

  // NOTE: replace the '[element]' with '\[element\]' using '\\$&'
  paramName = paramName.replace(/[[\]]/g, '\\$&');
  regExp    = new RegExp(`[?&]${paramName}(=([^&#]+)|&|#|$)`);
  results   = regExp.exec(url);

  if (!results)    return '';
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function load(url, options = {}) {
  var promise, file, key;

  key = url.split('?').shift();
  if (Object.hasOwnProperty.call(_files, key)) {return _files[key];}

  options.type = options.type || 'script';

  file = document.createElement(options.type);
  switch (options.type) {
    case 'link':
      file.type = 'text/css';
      file.rel  = 'stylesheet';
      file.href = url;
      break;
    case 'script':
    default:
      file.type = 'text/javascript';
      file.src = url;
      file.async = true;
      options.text && (file.text = options.text);
      break;
  }

  promise = new window.RSVP.Promise((resolve, reject) => {
    file.onload  = () => resolve(file);
    file.onerror = reject;

    document.head.appendChild(file);
  });

  _files[key]  = promise;
  return promise;
}

/**
 * Carga del JS para la publicidad de Google
 */
export function cargaLibreriaGPT() {
  var gads, useSSL, node;
  window.googletag     = window.googletag     || {};
  window.googletag.cmd = window.googletag.cmd || [];
  window.customcmd     = window.customcmd || [];
  try {
    if ($(`script[src*='${GPT_URL}']`).length === 0) {
      gads = document.createElement('script');
      gads.async = true;
      gads.type = 'text/javascript';
      useSSL = document.location.protocol === 'https:';
      gads.src = (useSSL ? 'https:' : 'http:') + `//${GPT_URL}`;
      node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(gads, node);
      window.googletag.cmd.push(function() {
        var func;
        showLog('First function', window.customcmd.length);
        while (window.customcmd.length) {
          func = window.customcmd.splice(0, 1)[0];
          window.googletag.cmd.push(func);
        }
        showLog('Finish Pushing to googletag.cmd', window.customcmd.length);
        window.customcmd = window.googletag.cmd;
      });
    }
  } catch (err) {
    showError('Utils:cargaLibreriaGPT:Error loading GPT library');
  }
}

export function extend() {
  var args = arguments;
  var objectValues = Object.keys(args).map(e => args[e]);
  // sustituto de Object.values(args)

  objectValues.forEach(function(argument, pos) {
    pos !== 0 && Object.keys(argument).forEach((key) => {
      args[0][key] = argument[key];
    });
  });

  return args[0];
}

export function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

export function startsWith(str, needle) {
  return str.indexOf(needle) === 0;
}

export function urlToSection(sectionUrl) {
  return sectionUrl.replace(/^\/|\/$/g, '');
}



// WEBPACK FOOTER //
// ./src/utils.js